import Worksheet from '../components/WorkSheet'

const WorkSheet = () => {
  return (
    <>
    <Worksheet />
    </>
  )
}

export default WorkSheet